import { PRESTA_BENEFITS } from "data/constants";
import { useAnimation, useInView } from "framer-motion";
import { useEffect, useRef } from "react";
import CallToActionHeader from "./CallToActionHeader";
import CallToFaqSection from "./CallToFaqSection";
import EventServicesCallToAction from "./HowItWorkCallToAction";
import PrestaCallToActionImage from "./PrestaCallToActionImage";
import { Helmet } from "react-helmet";

const PrestaCallToAction = () => {
  const benefitsRef = useRef(null);
  const callToActionImageRef = useRef(null);

  const benefitsControls = useAnimation();
  const callToActionImageControls = useAnimation();

  const isBenefitsInView = useInView(benefitsRef, { once: true, margin: "-100px" });
  const isCallToActionImageInView = useInView(callToActionImageRef, { once: true, margin: "-100px" });

  useEffect(() => {
    if (isBenefitsInView) {
      benefitsControls.start("visible");
    }
  }, [isBenefitsInView, benefitsControls]);

  useEffect(() => {
    if (isCallToActionImageInView) {
      callToActionImageControls.start("visible");
    }
  }, [isCallToActionImageInView, callToActionImageControls]);

  return (
    <>
      <Helmet>
        <title>
          Prestataire événementiel Paris, Île-de-France | Trouvez les meilleurs services | Event To Bee{" "}
        </title>
        <meta
          name="description"
          content="Trouvez votre prestataire événementiel à Paris, Île-de-France  : traiteurs, musiciens, animateurs, photographes. Des services sur mesure pour vos événements professionnels et privés."
        />
      </Helmet>
      <div className="bg-gradient-to-br from-gray-50 to-gray-200">
        <CallToActionHeader />
        <div ref={callToActionImageRef}>
          <PrestaCallToActionImage controls={callToActionImageControls} />
        </div>

        <div className="px-4 py-16 mt-20 dark:bg-neutral-800" ref={benefitsRef}>
          {/* Section Title */}
          <div className="mb-12 text-4xl font-extrabold text-center text-gray-800 md:text-5xl dark:text-white">
            <h2>Pourquoi référencer vos services sur EVENTTOBEE</h2>
          </div>

          {/* Benefits Section */}
          <div className="flex flex-col items-center justify-center gap-8 mx-auto md:flex-row max-w-7xl">
            {PRESTA_BENEFITS.map((value, index) => (
              <div key={value.id} className="relative flex justify-center text-center">
                <div className="p-6 rounded-xl">
                  <img src={value.icon} alt={value.title} width={100} height={100} className="mx-auto" />
                  <h5 className="mt-4 text-xl font-semibold text-gray-800 whitespace-nowrap">{value.title}</h5>
                  <p className="mt-2 leading-relaxed text-gray-600 dark:text-white">{value.description}</p>
                </div>
                {index < PRESTA_BENEFITS.length - 1 && (
                  <div className="hidden md:block absolute right-[-1rem] top-1/2 transform -translate-y-1/2 h-24 w-px bg-gray-300"></div>
                )}
              </div>
            ))}
          </div>
        </div>
        <EventServicesCallToAction />
        <CallToFaqSection />
      </div>
    </>
  );
};

export default PrestaCallToAction;
